import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BusinessPartner } from '../../../model/business_partner';

@Component({
  selector: 'app-add-business-partner-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule],
  templateUrl: './add-business-partner-dialog.html',
  styleUrl: './add-business-partner-dialog.css'
})
export class AddBusinessPartnerDialog implements OnChanges {
  @Output() closed = new EventEmitter<void>();
  @Output() submitPartner = new EventEmitter<{
    Id?: number | null;
    Name: string;
    LastName: string;
    Email: string;
    Phone: string;
    CompanyName: string;
  }>();
  @Input() submitting: boolean = false;
  @Input() mode: 'add' | 'edit' = 'add';
  @Input() initialPartner?: BusinessPartner | null;

  businessPartnerName: string = '';
  contactName: string = '';
  contactLastName: string = '';
  contactEmail: string = '';
  contactPhone: string = '';

  ngOnChanges(changes: SimpleChanges): void {
    if ('initialPartner' in changes && this.initialPartner) {
      const p = this.initialPartner;
      this.businessPartnerName = p.CompanyName || '';
      this.contactName = p.Name || '';
      this.contactLastName = p.LastName || '';
      this.contactEmail = p.Email || '';
      this.contactPhone = p.Phone || '';
    }
  }

  onCancel(): void { this.closed.emit(); }
  onSubmit(): void {
    this.submitPartner.emit({
      Id: this.mode === 'edit' ? (this.initialPartner?.Id ?? null) : undefined,
      Name: this.contactName,
      LastName: this.contactLastName || this.contactName,
      Email: this.contactEmail,
      Phone: this.contactPhone,
      CompanyName: this.businessPartnerName
    });
  }
}


